import FeatureRow from "./FeatureRow";
import SectionHeader from "./SectionHeader";
import { AccountsPreview, ContentBlockingPreview, ParentPlanPreview, ProgressPreview } from "./ProductPreviews";

function ParentSection() {
  return (
    <section data-ga-section="parent" className="iv1-cream-grain py-20 border-y border-black/5">
      <div className="max-w-screen-lg mx-auto px-6 flex flex-col gap-20">
        <SectionHeader
          eyebrow="For parents"
          title="Finally — screen time you can actually feel good about."
          sub="See what your child is learning without hovering. Set goals, read AI summaries over coffee, and know an endless feed isn't running your house."
        />
        <FeatureRow
          eyebrow="01 · Block it"
          title="Block what they shouldn't see."
          body="Add a YouTube channel or keyword you don't want, and matching videos stop getting recommended and won't show up in search — no negotiating, no explaining. You set the rules once."
          bullets={[
            "Block any YouTube channel in seconds",
            "Filter by keyword — block gaming, pranks, and more",
            "Changes apply instantly across every device",
          ]}
          preview={<ContentBlockingPreview />}
          tint="bg-pastelyellow-light"
        />
        <FeatureRow
          eyebrow="02 · Shape it"
          title="Plans, built around your child."
          body="Create a study plan in 60 seconds. Pick a subject, write a goal in plain language, and our AI maps out a learning path to reach it."
          bullets={[
            "Works for any age, any subject",
            "Parents and kids can both create plans",
            "Edit, reorder, or regenerate anytime",
          ]}
          preview={<ParentPlanPreview />}
          tint="bg-pastelpurple-light"
          reverse
        />
        <FeatureRow
          eyebrow="03 · Watch it happen"
          title="A weekly summary, not a spreadsheet."
          body="Every Sunday you get a readable email: what your child watched, what they mastered, where they got stuck, and a conversation prompt for dinner."
          bullets={[
            "Daily minutes, streaks, quiz accuracy",
            "AI-generated summaries — no digging required",
            "Email digest or in-app dashboard",
          ]}
          preview={<ProgressPreview />}
          tint="bg-pastelblue-light"
        />
        <FeatureRow
          eyebrow="04 · Share it"
          title="One account for the whole family."
          body="Each child gets their own profile, their own plans, and their own progress. You manage everything from one place."
          bullets={[
            "Separate profile per child",
            "Individual blocklists and limits",
            "One subscription, unlimited plans",
          ]}
          preview={<AccountsPreview />}
          tint="bg-pastelgreen-light"
          reverse
        />
      </div>
    </section>
  );
}

export default ParentSection;
